import { render } from "./InstanceIdentifier.vue?vue&type=template&id=7bb83ee6&scoped=true&ts=true"
import script from "./InstanceIdentifier.vue?vue&type=script&lang=ts"
export * from "./InstanceIdentifier.vue?vue&type=script&lang=ts"

import "./InstanceIdentifier.vue?vue&type=style&index=0&id=7bb83ee6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb83ee6"]])

export default __exports__